import type { CommunityLockReason } from '~/interfaces/community';

import { isConditionLock } from './communityAccess';

export type JoinGateStatus = 'joinable' | 'upgrade' | 'closed' | 'refused';

interface GateInputs {
  gated: boolean;
  accessible: boolean;
  hasPurchasableTier: boolean;
  lockReason: CommunityLockReason | null;
  isLoggedIn: boolean;
}

// joinable: open, the viewer already has access, or a guest the conditions can't be checked for until they sign in.
// refused: a signed-in viewer who doesn't meet the community's conditions, which take precedence over tiers.
// upgrade: gated, no access, but the upgrade modal has something to sell.
// closed: gated, no access, nothing to buy (private/closed community).
export const classifyJoinGate = ({
  gated,
  accessible,
  hasPurchasableTier,
  lockReason,
  isLoggedIn,
}: GateInputs): JoinGateStatus => {
  if (!gated || accessible) return 'joinable';
  if (isConditionLock(lockReason)) return isLoggedIn ? 'refused' : 'joinable';
  if (hasPurchasableTier) return 'upgrade';
  return 'closed';
};
